import { render } from "./SelectorMap.vue?vue&type=template&id=6067756c&scoped=true"
import script from "./SelectorMap.vue?vue&type=script&lang=js"
export * from "./SelectorMap.vue?vue&type=script&lang=js"

import "./SelectorMap.vue?vue&type=style&index=0&id=6067756c&scoped=true&lang=css"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6067756c"]])

export default __exports__